import { render, staticRenderFns } from "./classscheduletable.vue?vue&type=template&id=68509272&scoped=true"
import script from "./classscheduletable.vue?vue&type=script&lang=js"
export * from "./classscheduletable.vue?vue&type=script&lang=js"
import style0 from "./classscheduletable.vue?vue&type=style&index=0&id=68509272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68509272",
  null
  
)

export default component.exports